import React from 'react';
import ReactDOM from 'react-dom';
import { createStore, applyMiddleware, combineReducers } from 'redux';
import { Provider } from 'react-redux';
import { enableBatching } from 'redux-batched-actions';
import { composeWithDevTools } from 'redux-devtools-extension';
import createSagaMiddleware from 'redux-saga';
import * as reducers from '../modules';
import RouterSwitcher from './components/RouterSwitcher';
import { BrowserRouter } from 'react-router-dom';
import { watchFetchJobsClient } from '../sagas/search-client';
import initSticky from 'module-tsl-ui-components/es5/utils/sticky/sticky-positioner';
import { watchAddToProfile } from '../sagas/addToProfile';

const reducer = enableBatching(combineReducers(reducers));
const sagaMiddleware = createSagaMiddleware();
const store = createStore(reducer, window.__initialState__, composeWithDevTools(applyMiddleware(sagaMiddleware)));

sagaMiddleware.run(watchFetchJobsClient);
sagaMiddleware.run(watchAddToProfile);

import './sass/main.scss';

let wrap = Component => {
  return (
    <Provider store={store}>
      <BrowserRouter forceRefresh={!('pushState' in window.history)}>
        <Component />
      </BrowserRouter>
    </Provider>
  );
};
let firstTime = false;

const init = () => {
  !firstTime &&
    !!global.performance &&
    !!global.performance.mark &&
    (firstTime = true) &&
    global.performance.mark('tes-app-interactive');
  const elem = document.querySelector('.advert-container-mpu2');
  const footer = document.querySelector('.footer-nav__inner');
  if (!!elem && !!footer) {
    setTimeout(() => {
      initSticky({ elem, footer, appSelector: '.t-jobs-listing', contextualSelector: '.job-results-right' });
    }, 1000);
  }
};

const render = (Component) => {
  ReactDOM.hydrate(
    wrap(Component),
    document.getElementById('root'),
    init
  );
};

render(RouterSwitcher);
